import React from "react";
import { ASSET_PLACEHOLDER_IMAGE } from "../utils/assetFormatters";

const AssetMobileList = ({ assets, hasLoadedOnce, onSelectAsset }) => {
  if (assets.length === 0 && hasLoadedOnce) {
    return (
      <div className="flex h-[50vh] items-center justify-center">
        <img src="/images/empty.png" alt="Không có dữ liệu" />
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {assets.map((asset, index) => (
        <button
          key={asset._id || index}
          type="button"
          onClick={() => onSelectAsset(asset)}
          className="w-full rounded-md border border-[#EAEAEA] bg-white p-3 text-left transition-colors hover:bg-[#f9f9f9] motion-safe:animate-[fadeInUp_280ms_ease-out]"
          style={{ animationDelay: `${(index % 10) * 20}ms` }}
        >
          <div className="flex min-w-0 items-center gap-4">
            <img
              src={asset.image || ASSET_PLACEHOLDER_IMAGE}
              alt="Tài sản"
              className="size-20 shrink-0 rounded-md object-contain ring-1 ring-slate-100"
              onError={(event) => {
                event.currentTarget.src = ASSET_PLACEHOLDER_IMAGE;
              }}
            />
            <div className="min-w-0 flex-1 text-sm">
              <p className="truncate font-sf-medium text-gray-900">{asset.brand || asset.name}</p>
              <p className="truncate text-gray-600">Phân loại: {asset.classification || asset.type}</p>
              <p className="truncate text-gray-600">Số đơn: {asset.profileCode}</p>
              <p className="truncate text-gray-600">Ngày nộp đơn: {asset.submittedDate || asset.applicationDate}</p>
              <p className="truncate text-gray-600">Số bằng: {asset.certificateNumber}</p>
              <p className="truncate text-gray-600">Chủ sở hữu: {asset.owner}</p>
            </div>
          </div>
        </button>
      ))}

      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(6px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default AssetMobileList;